import PropTypes from 'prop-types';

import { Title } from '~/components';

import styles from './PostcodeSearchFormDescription.scss';

export const PostcodeSearchFormDescription = ({
  title = 'Property address',
  subtitle = 'Please find the address for the property where the appointment will take place.',
  additionalInfo = null,
}) => (
  <section className={styles.PostcodeSearchFormDescription}>
    <Title id="address-title" className={styles.Title} data-testid="search-form-title">
      {title}
    </Title>
    <p>{subtitle}</p>
    {additionalInfo && additionalInfo}
  </section>
);

PostcodeSearchFormDescription.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  additionalInfo: PropTypes.node,
};
